module.exports = __webpack_public_path__ + "img/KSC00886.65556403.jpg";